import { getOperateLineChart } from "@/api/operate";
import { filterOperateLevel } from "@/utils/format";

export default {
  data() {
    return {
      lineChartData: [],
    };
  },
  methods: {
    // 获取折线图数据
    getLineChartData() {
      getOperateLineChart({
        search: JSON.stringify(
          this.isRegion
            ? {
                Shop: this.info.region,
              }
            : { Region: this.info.region }
        ),
      }).then((rows) => {
        rows = filterOperateLevel(rows, this.isRegion);
        this.lineChartData = this.formatLineChartData(rows);
      });
    },
    // 处理折线图数据
    formatLineChartData(rows) {
      let obj = {};
      rows.forEach((row) => {
        if (obj[row.KPI]) {
          obj[row.KPI].push(row);
        } else {
          obj[row.KPI] = [row];
        }
      });
      return this.sortLineChartData(obj);
    },
    // 折线图数据排序
    sortLineChartData(data) {
      let arr = [];
      Object.keys(data).forEach((k) => {
        let ret = data[k];
        ret = ret
          .map((v) => ({
            timestamp: new Date(v.sYear, v.sMonth - 1),
            ...v,
          }))
          .sort((a, b) => a.timestamp - b.timestamp);
        arr.push({
          name: k,
          data: ret,
        });
      });
      return arr;
    },
  },
};
